@switch (type()) {
  @case ('stroked') {
    <button
      mat-stroked-button
      [class]="classString()"
      [disabled]="isDisabled()"
      [color]="color()"
    >
      <ng-container *ngTemplateOutlet="buttonContent" />
    </button>
  }
  @case ('flat') {
    <button
      mat-flat-button
      [class]="classString()"
      [disabled]="isDisabled()"
      [color]="color()"
    >
      <ng-container *ngTemplateOutlet="buttonContent" />
    </button>
  }
  @case ('raised') {
    <button
      mat-raised-button
      [class]="classString()"
      [disabled]="isDisabled()"
      [color]="color()"
    >
      <ng-container *ngTemplateOutlet="buttonContent" />
    </button>
  }
  @default {
    <button
      mat-button
      [class]="classString()"
      [disabled]="isDisabled()"
      [color]="color()"
    >
      <ng-container *ngTemplateOutlet="buttonContent" />
    </button>
  }
}

<ng-template #buttonContent>
  <div
    class="flex items-center"
    [ngClass]="cta() ? 'justify-left' : 'justify-center'"
  >
    <mat-icon class="loader" [@loaderAnimation]="loading() ? 'show' : 'hide'">
      <mat-spinner color="accent" diameter="20" />
    </mat-icon>
    <span><ng-content /></span>
  </div>
</ng-template>
